import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
// import { MatButtonModule } from '@angular/material/button';
// import { MatCheckboxModule } from '@angular/material/checkbox';
// import { MatFormFieldModule } from '@angular/material/form-field';
// import { MatInputModule } from '@angular/material/input';
// import { MatDialogModule } from '@angular/material/dialog';

// Shared componnets.
import { ButtonToggleComponent } from './toggle/toggle.component';

// Shared directives.
import { ADirective } from './a.directive';
import { AsyncClickDirective } from './async-click.directive';
import { ParallaxDirective } from './parallax.directive';
import { MatDetailRowDirective } from './mat-detail-row.directive';
import { BadgeComponent } from './badge/badge.component';
import { RouteSegmentUrlPipe } from './route-segment-url.pipe';
import { NgInitDirective } from './ng-init.directive';
import { TimeLeftComponent } from './time-left';
import { TimeLeftPipe } from './time-left.pipe';
import { TimeLeftExistPipe } from './time-left-exist.pipe';
import { MetricPipe } from './metric.pipe';
import { PercentPipe } from './percent.pipe';
import { OfferPipe } from './offer.pipe';
import { DiscountPipe } from './discount.pipe';
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        // MatButtonModule,
        // MatCheckboxModule,
        // MatFormFieldModule,
        // MatInputModule,
        // MatDialogModule
    ],
    declarations: [
        ButtonToggleComponent,

        ADirective,
        AsyncClickDirective,
        ParallaxDirective,
        MatDetailRowDirective,
        BadgeComponent,
        RouteSegmentUrlPipe,
        NgInitDirective,
        TimeLeftComponent,
        TimeLeftPipe,
        TimeLeftExistPipe,
        MetricPipe,
        PercentPipe,
        OfferPipe,
        DiscountPipe
    ],
    exports: [
        CommonModule,
        FormsModule,
        // MatButtonModule,
        // MatCheckboxModule,
        // MatFormFieldModule,
        // MatInputModule,
        // MatDialogModule,
        ADirective,
        AsyncClickDirective,
        ParallaxDirective,
        MatDetailRowDirective,
        BadgeComponent,
        RouteSegmentUrlPipe,
        NgInitDirective,
        ButtonToggleComponent,
        TimeLeftComponent,
        TimeLeftPipe,
        TimeLeftExistPipe,
        MetricPipe,
        PercentPipe,
        OfferPipe,
        DiscountPipe
    ],
    entryComponents: [
    ]
})
export class SharedModule {
}
